const megamenu = {
  links: document.querySelectorAll(
    '.jsMegamenuLinks',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setOverlay();
  },

  setOverlay() {
    this.links.forEach((item) => {
      const overlay = item.querySelector('.desc-nav__overlay') as HTMLElement;

      item.addEventListener('mouseenter', () => {
        item.classList.add('activeClass');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('activeClass');
      });

      overlay.addEventListener('mouseenter', () => {
        item.classList.remove('activeClass');
      });
    });
  },
};

export default megamenu;
